import type { ReactNode } from 'react'

import { IconAlertCircle } from '@tabler/icons-react'

import { Cell, Row, RowButton } from 'components/Lists'

import { IconBackground } from './IconBackground'
import { Subtitle } from './Subtitle'

type Props = {
	title: ReactNode
	subtitle?: ReactNode
	icon?: ReactNode
	type?: 'action' | 'danger' | 'warning'

	onClick?: () => Awaitable<void>
}

export const ItemIcon = ({ title, subtitle, icon, type, onClick }: Props) => {
	const content = (
		<>
			<Cell>
				<IconBackground type={type}>{icon ?? <IconAlertCircle />}</IconBackground>
			</Cell>
			<Cell shouldExpand>
				{title}
				<Subtitle>{subtitle}</Subtitle>
			</Cell>
		</>
	)

	return onClick ? <RowButton onClick={onClick}>{content}</RowButton> : <Row>{content}</Row>
}
